module.exports = __webpack_public_path__ + "media/home2-center.73da1e60.mp4";